
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_27900","data-name":"Group 27900","xmlns":"http://www.w3.org/2000/svg","width":"12.06","height":"12.06"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-action-info"}},[_c('rect',{attrs:{"id":"Rectangle_8383","data-name":"Rectangle 8383","width":"12.06","height":"12.06","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_27898","data-name":"Group 27898","clip-path":"url(#clip-path-action-info)"}},[_c('path',{attrs:{"id":"Path_20748","data-name":"Path 20748","d":"M7.17 3.92c-.02.02-.03.04-.05.05a.8.8 0 01-.6.23.8.8 0 01-.6-.23.741.741 0 010-1.11.83.83 0 01.6-.24.847.847 0 01.6.24.746.746 0 01.05 1.06","fill":"#acb2bd"}}),_c('path',{attrs:{"id":"Path_20749","data-name":"Path 20749","d":"M7.28 8.68l-.1.39c-.28.11-.51.19-.68.25a1.964 1.964 0 01-.59.09 1.161 1.161 0 01-.8-.25.837.837 0 01-.29-.64c0-.1.01-.21.02-.31s.04-.22.07-.35l.35-1.26a2.852 2.852 0 00.08-.35 1.544 1.544 0 00.04-.3.481.481 0 00-.1-.33.518.518 0 00-.38-.09.863.863 0 00-.28.04c-.1.03-.18.06-.25.08l.09-.39c.24-.09.46-.17.67-.24a2.039 2.039 0 01.6-.1 1.12 1.12 0 01.79.25.8.8 0 01.28.64 1.867 1.867 0 01-.02.29 1.6 1.6 0 01-.07.38l-.35 1.25a2.609 2.609 0 00-.08.35 1.428 1.428 0 00-.03.29.386.386 0 00.11.34.532.532 0 00.39.09 1.012 1.012 0 00.29-.04 2.251 2.251 0 00.24-.08","fill":"#acb2bd"}}),_c('circle',{attrs:{"id":"Ellipse_441","data-name":"Ellipse 441","cx":"5.53","cy":"5.53","r":"5.53","transform":"translate(.5 .5)","fill":"none","stroke":"#acb2bd","stroke-width":"1"}})])])
          )
        }
      }
    